import {
    IBasePicker,
    ITag,
    Label,
    TagPicker,
    Text
} from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { RootState } from 'app/store';
import { EControlType } from 'components/ControlWrapper';
import { textProp } from 'global/Application';
import { bcbs_config_attribute, bcbs_copaycoinoption } from 'model/AttributeOptionSets.type';
import * as IXrmTypes from 'model/CRM';
import * as FAM from 'model/FlexibleAttributeModel';
import React, { useMemo, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { TagItem } from './TagItem';

interface IProps extends TComponentConnectedProps {

    label?: string;
    fieldValueOnChange?: (event: any, value: FAM.IEntityReferenceValue | null) => void;
    defaultFieldValue?: FAM.IEntityReferenceValue;
    category?: IXrmTypes.bcbs_config_category;
    costshareCategory?: IXrmTypes.bcbs_config_category;
    masterAttribute?: IXrmTypes.bcbs_config_masterattribute;
    configAttribute?: IXrmTypes.bcbs_config_attribute;
    disabled?: boolean;
    controlType?: EControlType
}

export interface IItemTag<T> extends ITag {
    search?: string;
    data?: T;
}

const entityToTag = (entity: FAM.IEntityReferenceValue) => {
    const t: IItemTag<FAM.IEntityReferenceValue> = {
        key: entity.id,
        name: entity.name,
        search: entity.name,
        data: entity
    }

    return t;
}

const Costshare: React.FC<IProps> = (props) => {

    const pickerInputId = useId();
    const [selectedItems, setSelectedItems] = useState<IItemTag<FAM.IEntityReferenceValue>[]>(props.defaultFieldValue
        ? [entityToTag(props.defaultFieldValue)]
        : []
    );

    // avoiding making controls as controlled component as much as we can
    // useEffect(() => {
    //     if (props.defaultFieldValue)
    //         setSelectedItems([entityToTag(props.defaultFieldValue)]);
    //     else
    //         setSelectedItems([]);
    // }, [props.defaultFieldValue])
    const searchData = useMemo(() => {

        // allow some override on costshare by category:
        // current use case is for nonStandards, since they are their own category
        // needed a way to specify the category
        let categoryCostshare = props.costshareCategory;

        if (!categoryCostshare)
            categoryCostshare = props.category;

        const result: IItemTag<FAM.IEntityReferenceValue>[] = [];

        props.state?.data.config?.cache?.map_bcbs_copaycoinoption_type[categoryCostshare?.bcbs_config_categoryid!]?.forEach(q => {

            // Ignoring inactive records.
            // Active	1
            // Inactive	2
            if (q.statuscode === 2) {
                return;
            }

            if (props.configAttribute?.bcbs_costsharetypecode === bcbs_config_attribute.bcbs_costsharetypecode['Currency Only(808900001)'].value) {
                if (!q.bcbs_iscurrencyonly)
                    return;
            } else if (props.configAttribute?.bcbs_costsharetypecode === bcbs_config_attribute.bcbs_costsharetypecode['Percentage Only(808900002)'].value) {
                if (!q.bcbs_ispercentageonly)
                    return;
            } else if (props.configAttribute?.bcbs_costsharetypecode === bcbs_config_attribute.bcbs_costsharetypecode['All(808900000)'].value) {

            }

            const t: IItemTag<FAM.IEntityReferenceValue> = {
                key: q.bcbs_copaycoinoptionid,
                name: q.bcbs_name,
                data: {
                    type: 'entity',
                    id: q.bcbs_copaycoinoptionid,
                    name: q.bcbs_name,
                    entityType: 'bcbs_copaycoinoption',
                },
                search: q.bcbs_name.toLowerCase()
            }

            result.push(t);
        });

        return result;
    }, [props.state.data.config, props.costshareCategory, props.category]);

    const picker = React.useRef<IBasePicker<ITag>>(null);

    const listContainsTagList = (tag: ITag, tagList?: ITag[]) => {
        if (!tagList || !tagList.length || tagList.length === 0) {
            return false;
        }
        return tagList.some(compareTag => compareTag.key === tag.key);
    };

    const onItemSelected = React.useCallback((item?: ITag): ITag | null => {
        if (item && picker.current && listContainsTagList(item, picker.current.items)) {
            return null;
        }
        return item!;
    }, []);

    const pickerRef = React.useRef(null);

    if (props.disabled)
        return <div style={textProp.root.style}>
            <Label styles={textProp.label}>{props.label}</Label>
            <Text styles={textProp.textStyles}>{props?.defaultFieldValue?.name ?? '---'}</Text>
        </div>;


    return (
        <>
            <Label>{props.label}</Label>
            <TagPicker
                ref={pickerRef}
                itemLimit={1}
                onResolveSuggestions={(filter, selected) => {
                    const _filter = filter.toLowerCase();
                    // return searchData.filter(t => t.search!.toLowerCase().indexOf(_filter) > -1);

                    const ret: typeof searchData = [];
                    let i = 0;
                    for (const t of searchData)
                        if (t.search!.toLowerCase().indexOf(_filter) > -1) {
                            ret.push(t);

                            if (++i > 25)
                                break;
                        }

                    return ret;
                }}
                onBlur={(event) => {
                    // empty as soon as focus leaves
                    if (pickerRef.current)
                        //@ts-expect-error TS2339
                        pickerRef?.current?.input?.current?._updateValue?.("");
                }}
                disabled={props.disabled}
                onChange={(items?: IItemTag<FAM.IEntityReferenceValue>[]) => {
                    props.fieldValueOnChange?.(null, items?.[0]?.data ?? null);
                    setSelectedItems(items ?? []);
                }}
                onItemSelected={onItemSelected}
                selectedItems={selectedItems}
                getTextFromItem={(item) => item.name}

                inputProps={{
                    // onBlur: (ev: React.FocusEvent<HTMLInputElement>) => console.log('onBlur called'),
                    // onFocus: (ev: React.FocusEvent<HTMLInputElement>) => console.log('onFocus called'),
                    id: pickerInputId,
                    placeholder: 'Costshare',

                    onPaste: async (event) => {
                        try {
                            const clipboardData = event.clipboardData.getData('text/plain')
                            const costShareJson = JSON.parse(clipboardData);

                            if (costShareJson?.key) {
                                event.preventDefault();
                                event.stopPropagation();
                                const costshare = searchData.filter(q => q.key === costShareJson.key);
                                const items = costshare;


                                setTimeout(() => {
                                    if (costshare) {
                                        props.fieldValueOnChange?.(null, items?.[0]?.data ?? null);
                                        setSelectedItems(items ?? []);
                                    }
                                }, 0);

                            }
                        } catch {

                        }
                        // const clipboardContents = await navigator.clipboard.read();
                        // for (const item of clipboardContents) {
                        //     if (!item.types.includes('image/png')) {
                        //         throw new Error('Clipboard contains non-image data.');
                        //     }
                        //     const blob = await item.getType('text/plain');
                        //     const content = await blob.text()

                        // }

                    }

                }}
                onRenderItem={(props) => {
                    return <TagItem {...props} >{props.item.name}</TagItem>
                }}
            // pickerSuggestionsProps={{
            //     suggestionsHeaderText: 'Suggested tags',
            //     noResultsFoundText: 'No color tags found',
            // }}
            />
        </>

    )
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(Costshare)
